import _ from 'lodash';
import { createSelector } from 'reselect';

const organizationSelector = state => state.organization;

const salesforceBaseUrlSelector = (organization) => {

  const organizationData = organization.data || {};

  if(organizationData.integrations && organizationData.integrations.salesforce && organizationData.integrations.salesforce.status === 'live' && organizationData.integrations.salesforce.instanceUrl){
    return organizationData.integrations.salesforce.instanceUrl;
  }
  else{
    return false;
  }
}

export default createSelector(
  organizationSelector,
  salesforceBaseUrlSelector
)



// WEBPACK FOOTER //
// ./src/selectors/salesforceBaseUrlSelector.js